import { Component, OnInit, ChangeDetectorRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { EducationFormService } from './services/education-form.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { CommonHelper } from '../../../utilities/common.helper';
import { NgForm, Validators } from '@angular/forms';
import { decrypt, encrypt } from '../../../utilities/utilityFunctions';
import { LoaderService } from '../../sharedServices/loader.service';

@Component({
	selector: 'kt-education-form',
	templateUrl: './education-form.component.html',
	styleUrls: ['./education-form.component.scss']
})
export class EducationFormComponent implements OnInit {
	// public educationDetailsData:any;
	@ViewChild('educationDetailsForm', { static: false }) educationDetailsForm: NgForm;
	public loader: boolean = false;
	public todayDate = new Date();
	public selectedCountry: number;
	public selectedQualification: number;
	public qualId: any;
	public countryId: any;
	public instituteId: any;
	public gradingId: any;
	public qualificationLevel: any = [];
	public universityId: any;
	public totalMarksGpaPlaceHolder: string = 'Enter Obtained CGPA';
	public totalMarksGpaDisplayName: string = 'Obtained CGPA';
	public qualificationCode: any;
	public programId: any;
	public departmentId: any
	public campusId: any;
	public degreeTypeId: any;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public startDate: any;
	public endDate: any;
	public futureDate: Date = new Date(Date.now() + (3600 * 1000 * 24 * 7 * 30 * 365));
	public alertMsgValue: string;
	public isEduAlertVisible: boolean = false;
	public maxGpaValue: number = 0;
	public isEducationInComplete: boolean = false;
	public isCurrentlyEnrolled: boolean = false;
	public isMarksCorrect: boolean = false;
	public greaterThanOrEqualErrorMessage: string;
	public loggedInUserFullName: any;
	public isResearchWork: string = 'false';
	@Output() startDateUpdated = new EventEmitter();
	@Output() endDateUpdated = new EventEmitter();
	@Output() educationUpdated = new EventEmitter();
	@Output() cancelEducation = new EventEmitter();
	public dateOfBirth: any;
	@Input('formViewType') formViewType: any;
	@Input('isDesStream') isDesStream: boolean;
	@Input('desId') desId: any;
	public step = 0;
	@Input('educationDetailsData') educationDetailsData: any;
	@Input('dropdownList') dropdownList: any;
	public equalToErrorMessage;
	@Input('formType') formType: string;
	public isAnyEducationCurrentlyEnrolled: boolean = false;
	public currentlyEnrolledEducationName: string;
	@Input('educationDetailGridData') educationDetailGridData;
	constructor(private educationDetailsService: EducationFormService,
		private loaderService: LoaderService,
		private cdr: ChangeDetectorRef, private sharedServices: SharedService) {
				// IPFP
		// const stored = localStorage.getItem('ipfpData');
		// if (stored) {
		// 	const appFormDataService = JSON.parse(stored);
		// 	console.log("Form view inside IPFP Education: ", appFormDataService);

		// 	this.formType = appFormDataService.formView;
		// 	this.formViewType = appFormDataService.formView;
		// 	// debugger
		// }
		// console.log("Form Type 2 Ed form: ", this.formViewType);
			
		let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		this.loggedInUserFullName = data['fullName'];

	}

	async ngOnInit() {
		this.dateOfBirth = new Date(+decrypt(localStorage.getItem(('dob'))))
		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			if (this.educationDetailGridData[i].currentEnrolmentInd && this.educationDetailGridData[i].educationId != this.educationDetailsData.educationId) {
				this.currentlyEnrolledEducationName = this.educationDetailGridData[i].qualificationLevel
				this.isAnyEducationCurrentlyEnrolled = true;
			}
		}
		this.dropdownList.gpaList = [{ label: '4.0', value: 4 }, { label: '5.0', value: 5 }]
		await this.getQualificationLevel();
		this.openEducationDetails(this.educationDetailsData, this.formViewType);

	}
	public getQualificationLevel() {
		this.loader = true;
		this.loaderService.setValue(this.loader)
		return new Promise((resolve, reject) => {
			this.educationDetailsService.getQualificationLevel().subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.qualificationLevel = res.data;
						resolve(this.qualificationLevel);
						this.cdr.detectChanges();
					}
				}
			)
		})
			.catch(function (error) {
				console.log(error)
			})
	}


	public getUniversityListByCountryForAboveHSC(countryId) {
		return new Promise((resolve, reject) => {
			if (countryId != undefined) {
				this.educationDetailsService.getUniversityListByCountryForAboveHSC(countryId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeInstituteList = res.data;
							resolve(this.dropdownList.degreeInstituteList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityListByCountryForBelowHSC(countryId, qualificationId) {
		return new Promise((resolve, reject) => {
			if (countryId != undefined) {
				this.educationDetailsService.getUniversityListByCountryForBelowHSC(countryId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeInstituteListByBoard = res.data;
							resolve(this.dropdownList.degreeInstituteListByBoard);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDegreeProgramForNonHSCorSSC(universityId, qualificationId) {
		return new Promise((resolve, reject) => {
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeProgramForNonHSCorSSC(universityId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeProgramList = res.data;
							resolve(this.dropdownList.degreeProgramList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getDicsiplineListByQualId(qualificationId){
		this.dropdownList.disciplineList = []
		return new Promise((resolve, reject) => {
		if(qualificationId != undefined ){
		  if(qualificationId == 7){
		  this.dropdownList.disciplineList = [{"label":"Arts","value":11926},{"label":"Commerce","value":11927},{"label":"Science","value":11928},{"label":"Technical","value":11929},{"label":"O-level","value":11930}];
		}
		  this.educationDetailsService.getDicsiplineListByQualId(qualificationId).subscribe(
		  (res:HecResponse)=>{
			if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
			  this.dropdownList.disciplineList = res.data;
			  resolve(this.dropdownList.disciplineList);
			  this.cdr.detectChanges();
			  this.cdr.markForCheck();
			}else{

			}
		  },
		  (err)=>{

		  }
		)
	  }
	})
	.catch(function (error) {
	  console.log(error)
	})
	  }

	public getDegreeProdgramListHSCorSSC(universityId, qualificationId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeProgramListForHSCorSSC(universityId, qualificationId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeProgramList = res.data;
							resolve(this.dropdownList.degreeProgramList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityNameOnDegree(universityId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityChangeNames(universityId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.universityNameList = res.data;
							resolve(this.dropdownList.universityNameList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getDataFromUniversityDegreeProgram(programId) {
		this.programId = programId
		this.getUniversityCampuses(this.qualId, this.instituteId, programId);
	}

	public getDataFromUniversityCampus(campusId) {
		this.campusId = campusId
		this.getUniversityDepartments(this.qualId, this.instituteId, this.programId, campusId);
	}

	public getDataFromUniversityDepartment(departmentId) {
		this.departmentId = departmentId;
		this.getUniversityDegreeTypes(this.qualId, this.instituteId, this.programId, this.campusId, departmentId);
	}

	public getDataFromUniversityDegreeType(degreeTypeId) {
		this.degreeTypeId = degreeTypeId;
		if (this.countryId == 1) {
			this.getUniversitySessionsList(this.qualId, this.instituteId, this.programId, this.campusId, this.departmentId, degreeTypeId);
		}
	}

	public getUniversityCampuses(qualificationId, universityId, universityDegreeProgramId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityCampus(qualificationId, universityId, universityDegreeProgramId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.campusList = res.data;
							resolve(this.dropdownList.campusList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDepartments(qualificationId, universityId, universityDegreeProgramId, campusId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDepartments(qualificationId, universityId, universityDegreeProgramId, campusId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.departmentList = res.data;
							resolve(this.dropdownList.departmentList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversityDegreeTypes(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversityDegreeType(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.degreeTypesList = res.data;
							resolve(this.dropdownList.degreeTypesList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getUniversitySessionsList(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId, degreeTypeId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService.getUniversitySessions(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId, degreeTypeId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.sessionTypesList = res.data;
							resolve(this.dropdownList.sessionTypesList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getEducationMajorList(disciplineId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (disciplineId != undefined) {
				this.educationDetailsService.getEducationMajorList(disciplineId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.majorList = res.data;
							resolve(this.dropdownList.majorList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public getCitiesByCountry(countryId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (countryId != undefined) {
				this.sharedServices.getCitiesByCountryId(countryId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.cityList = res.data;
							resolve(this.dropdownList.cityList);
							this.cdr.detectChanges();
						} else {

						}
					},
					(err) => {

					}
				)
			}
		})
			.catch(function (error) {
				console.log(error)
			})
	}

	public async openEducationDetails(data, type) {
		this.formViewType = type;
		this.getSelectedQualificationLevel(data.qualificationId);
		this.getIncompleteEduStatus(data.isIncompleteEducation);
		this.getCurrentlyEnrolledStatus(data.currentEnrolmentInd);
		await this.getSelectedCountryId(data.countryId)
		this.getSelectedQualificationLevel(data.qualificationId)
		await this.getSelectedInstitutId(data.universityId);

		if (data.countryId == 1) {
			await this.getUniversityCampuses(data.qualificationId, data.universityId, data.degreeProgramId)
			if (data.qualificationId != 7 && data.qualificationId != 8) {
				await this.getUniversityDepartments(data.qualificationId, data.universityId, data.degreeProgramId, data.campusId)

				await this.getUniversityDegreeTypes(data.qualificationId, data.universityId, data.degreeProgramId, data.campusId, data.universityDepartmentId)
				await this.getUniversitySessionsList(data.qualificationId, data.universityId, data.degreeProgramId, data.campusId, data.universityDepartmentId, data.degreeTypeId)
			}
		} else {
			await this.getEducationMajorList(data.subjectId)
			this.dropdownList.degreeTypesList = this.dropdownList.degreeTypeList
			this.dropdownList.sessionTypesList = this.dropdownList.sessionTypeList;
		}
		this.getSelectedGpaValue(data.totalCGPAMarks, 'get');
		if (data.qualificationId != 7 && data.qualificationId != 8) {
			this.getGradingType(data.gradingSystemCodeId)
		} else {
			this.gradingId == 10543;
		}
		await this.getUniversityNameOnDegree(data.universityId);
		data.startDate = data.startDate
		data.endDate = data.endDate
		if (this.educationDetailGridData.length > 1) {
			this.getDateValue((new Date(data.startDate).getFullYear() + '-' + (new Date(data.startDate).getMonth() + 1) + '-' + new Date(data.startDate).getDate()), 'start', undefined, 'get')
		}
		// this.getDateValue((new Date(data.endDate).getFullYear() +'-'+(new Date(data.endDate).getMonth()+1)+'-'+new Date(data.endDate).getDate()),'end')
		this.educationDetailsData = data;
		// this.newEducationAddFormDisplay = true;
		this.loader = false;
		this.loaderService.setValue(this.loader)
		this.cdr.markForCheck();
		this.cdr.detectChanges();

	}

	public async getSelectedInstitutId(instituteId, type?) {
		this.instituteId = instituteId
		if (type) {
			this.dropdownList.campusList = [];
			this.dropdownList.degreeProgramList = [];

			if (this.educationDetailsForm.form.controls.campusId)
				this.educationDetailsForm.form.controls.campusId.reset();
			if (this.educationDetailsForm.form.controls.otherCampus)
				this.educationDetailsForm.form.controls.otherCampus.reset();
			if (this.educationDetailsForm.form.controls.universityDepartmentId)
				this.educationDetailsForm.form.controls.universityDepartmentId.reset();
			if (this.educationDetailsForm.form.controls.otherDepartmentName)
				this.educationDetailsForm.form.controls.otherDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.degreeTypeId)
				this.educationDetailsForm.form.controls.degreeTypeId.reset();
			if (this.educationDetailsForm.form.controls.sessionTypeId)
				this.educationDetailsForm.form.controls.sessionTypeId.reset();
			if (this.educationDetailsForm.form.controls.specializationSubjectId)
				this.educationDetailsForm.form.controls.specializationSubjectId.reset();
			if (this.educationDetailsForm.form.controls.isResearchWork)
				this.educationDetailsForm.form.controls.isResearchWork.reset();
			if (this.educationDetailsForm.form.controls.isFcpsDegree)
				this.educationDetailsForm.form.controls.isFcpsDegree.reset();
		}
		if ((this.qualId != 7 && this.qualId != 8) && this.countryId == 1) {
			await this.getUniversityDegreeProgramForNonHSCorSSC(this.instituteId, this.qualId)
		} else {
			await this.getDegreeProdgramListHSCorSSC(this.instituteId, this.qualId);
		}
		await this.getUniversityNameOnDegree(instituteId);

	}

	public getSelectedQualificationLevel(qualId, type?) {
		if (type == 'update') {
			this.dropdownList.campusList = [];
			this.dropdownList.degreeInstituteList = [];
			this.dropdownList.degreeProgramList = [];
			this.dropdownList.disciplineList = [];
			this.dropdownList.universityNameList = []
			this.educationDetailsForm.form.controls.countryId.reset();
			if (this.educationDetailsForm.form.controls.cityId) {
				this.educationDetailsForm.form.controls.cityId.reset();
			}
			if (this.educationDetailsForm.form.controls.universityId)
				this.educationDetailsForm.form.controls.universityId.reset();
			if (this.educationDetailsForm.form.controls.schoolCollegeDepartmentName)
				this.educationDetailsForm.form.controls.schoolCollegeDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.sectorCode)
				this.educationDetailsForm.form.controls.sectorCode.reset();
			if (this.educationDetailsForm.form.controls.universityDegreeProgramId)
				this.educationDetailsForm.form.controls.universityDegreeProgramId.reset();
			if (this.educationDetailsForm.form.controls.otherProgramTitle)
				this.educationDetailsForm.form.controls.otherProgramTitle.reset();
			if (this.educationDetailsForm.form.controls.subjectId)
				this.educationDetailsForm.form.controls.subjectId.reset();
			if (this.educationDetailsForm.form.controls.otherUniversity)
				this.educationDetailsForm.form.controls.otherUniversity.reset();
			if (this.educationDetailsForm.form.controls.universityNameOnDegreeId)
				this.educationDetailsForm.form.controls.universityNameOnDegreeId.reset();
			if (this.educationDetailsForm.form.controls.campusId)
				this.educationDetailsForm.form.controls.campusId.reset();
			if (this.educationDetailsForm.form.controls.otherCampus)
				this.educationDetailsForm.form.controls.otherCampus.reset();
			if (this.educationDetailsForm.form.controls.universityDepartmentId)
				this.educationDetailsForm.form.controls.universityDepartmentId.reset();
			if (this.educationDetailsForm.form.controls.otherDepartmentName)
				this.educationDetailsForm.form.controls.otherDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.degreeTypeId)
				this.educationDetailsForm.form.controls.degreeTypeId.reset();
			if (this.educationDetailsForm.form.controls.sessionTypeId)
				this.educationDetailsForm.form.controls.sessionTypeId.reset();
			if (this.educationDetailsForm.form.controls.specializationSubjectId)
				this.educationDetailsForm.form.controls.specializationSubjectId.reset();
			if (this.educationDetailsForm.form.controls.isResearchWork)
				this.educationDetailsForm.form.controls.isResearchWork.reset();
			if (this.educationDetailsForm.form.controls.areaResearch)
				this.educationDetailsForm.form.controls.areaResearch.reset();
			if (this.educationDetailsForm.form.controls.gradingSystemCodeId)
				this.educationDetailsForm.form.controls.gradingSystemCodeId.reset();
			if (this.educationDetailsForm.form.controls.registrationNumber)
				this.educationDetailsForm.form.controls.registrationNumber.reset();
			if (this.educationDetailsForm.form.controls.examSystemTypeCode)
				this.educationDetailsForm.form.controls.examSystemTypeCode.reset();
			if (this.educationDetailsForm.form.controls.totalCGPAMarks)
				this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
				this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedPercentage)
				this.educationDetailsForm.form.controls.obtainedPercentage.reset();
		}
		this.qualId = qualId
		if (this.qualId == 7 || this.qualId == 8) {
			this.gradingId = 10543;
			this.totalMarksGpaDisplayName = 'Obtained Marks'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained Marks'
		} else {
			this.gradingId = undefined
		}
		this.isResearchWork = 'No';
	}

	public async getSelectedCountryId(countryId) {
		this.countryId = countryId
		if (this.educationDetailsForm.form.controls.subjectId)
			this.educationDetailsForm.form.controls.subjectId.reset();
		for (let i = 0; i < this.qualificationLevel.length; i++) {
			if (this.qualificationLevel[i].id == this.qualId) {
				this.qualificationCode = this.qualificationLevel[i].levelCodeId;
			}
		}
		await this.getDicsiplineListByQualId(this.qualId);
		await this.getCitiesByCountry(countryId);
		if (countryId == 1 && (this.qualId == 7 || this.qualId == 8)) {
			await this.getUniversityListByCountryForBelowHSC(countryId, this.qualificationCode)
		} else {
			await this.getUniversityListByCountryForAboveHSC(countryId)
		}

		if (countryId != 1) {
			this.dropdownList.degreeTypesList = this.dropdownList.degreeTypeList
			this.dropdownList.sessionTypesList = this.dropdownList.sessionTypeList;
		}
	}


	public getGradingType(gradingId) {
		this.gradingId = gradingId;
		if (gradingId == 10541) {
			this.totalMarksGpaDisplayName = 'Obtained CGPA'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained CGPA'
		} else if (gradingId == 10543) {
			this.totalMarksGpaDisplayName = 'Obtained Marks'
			this.totalMarksGpaPlaceHolder = 'Enter Obtained Marks'

		}
	}

	public getSelectedGpaValue(gpaValue, type?) {
		this.maxGpaValue = gpaValue;
		if (type == undefined) {
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset()
		}
		this.cdr.detectChanges();
	}

	public getObtainedMarksGpaValue(event) {
		if (+event.target.value > +this.maxGpaValue) {
			this.isMarksCorrect = false;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors({ max: true })
		}
		else if (+event.target.value < 0) {
			this.isMarksCorrect = false;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors({ min: true })
		} else {
			this.isMarksCorrect = true;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors(null)

		}
	}

	public getDateValue(date, field, eduId?, formtype?) {
		if (field == 'end' && String(date) == String(this.startDate)) {
			this.greaterThanOrEqualErrorMessage = "End date should be greater than Start date";
			this.cdr.detectChanges();
		}
		if (field == 'start') {
			this.startDate = new Date(date);
			this.cdr.detectChanges();
		}

		if (field == 'start' && formtype == undefined) {
			this.educationDetailsForm.form.controls.endDate.reset();
		}
		// if (this.formViewType != 'view') {
		// 	for (let i = 0; i < this.educationDetailGridData.length; i++) {
		// 		let check = new Date(date).getFullYear() + '-' + new Date(date).getMonth() + '-' + new Date(date).getDate()
		// 		let from = new Date(this.educationDetailGridData[i].startDate).getFullYear() + '-' + new Date(this.educationDetailGridData[i].startDate).getMonth() + '-' + new Date(this.educationDetailGridData[i].startDate).getDate()
		// 		let to = new Date(this.educationDetailGridData[i].endDate).getFullYear() + '-' + new Date(this.educationDetailGridData[i].endDate).getMonth() + '-' + new Date(this.educationDetailGridData[i].endDate).getDate()
		// 		if (check > from && check < to && eduId != this.educationDetailGridData[i].educationId) {
		// 			this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		// 			this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' education. Please change your date selection.')
		// 			this.isEduAlertVisible = true;
		// 			this.cdr.detectChanges();
		// 			if (field == 'start') {
		// 				this.educationDetailsForm.form.controls.startDate.setErrors({ equalTo: true });
		// 				if (this.formViewType == 'edit') {
		// 					this.markFormsTouched(this.educationDetailsForm)
		// 				}
		// 				this.cdr.detectChanges();
		// 				return;
		// 			} else if (field == 'end') {
		// 				this.endDate = date;
		// 				this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
		// 				return;
		// 			}
		// 		} else if (field == 'start' && (new Date(this.startDate) < new Date(this.educationDetailGridData[i].startDate) &&
		// 			new Date(this.educationDetailGridData[i].endDate) < new Date(this.endDate)) && eduId != this.educationDetailGridData[i].educationId) {
		// 			this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
		// 			this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		// 			this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' education. Please change your date selection.')
		// 			this.isEduAlertVisible = true;
		// 			return;

		// 		}
		// 		else if (field == 'end' && (new Date(this.startDate) < new Date(this.educationDetailGridData[i].startDate) &&
		// 			new Date(this.educationDetailGridData[i].endDate) < new Date(date)) && eduId != this.educationDetailGridData[i].educationId) {
		// 			this.educationDetailsForm.form.controls.endDate.setErrors({ equalTo: true });
		// 			this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		// 			this.alertBoxMsg('Your current date selection overlaps the duration of your ' + this.equalToErrorMessage + ' education. Please change your date selection.')
		// 			this.isEduAlertVisible = true;
		// 			return;
		// 		}
		// 		else {
		// 			this.isEduAlertVisible = false;
		// 			this.cdr.detectChanges();
		// 		}
		// 	}
		// }
	}

	public getResearchWork(event) {
		if(event && event.isTrusted){

		this.isResearchWork = (event.isTrusted == true) ? "Yes" : "Np";
		}
		else{
			this.isResearchWork = event;
		}
	}

	public cancelContact() {
		this.cancelEducation.emit('cancel')
	}

	setStep(index: number) {
		this.step = index;
	}

	nextStep() {
		this.step++;
	}

	prevStep() {
		this.step--;
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public getIncompleteEduStatus(event, type?) {
		this.isEducationInComplete = event;
		this.isCurrentlyEnrolled = false;
		if (type) {
			this.educationDetailsData.currentEnrolmentInd = undefined
			this.educationDetailsForm.form.controls.currentEnrolmentInd.reset();
		}
	}

	public getCurrentlyEnrolledStatus(event, type?) {
		this.isCurrentlyEnrolled = event;
		if ((event && type != undefined) || (!event && type != undefined)) {
			this.educationDetailsForm.form.controls.endDate.reset();
			if (this.educationDetailsForm.form.controls.totalCGPAMarks)
				this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
				this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedPercentage)
				this.educationDetailsForm.form.controls.obtainedPercentage.reset();

		}
	}

	public saveEducation() {
		this.markFormsTouched(this.educationDetailsForm)
		if (this.validate(this.educationDetailsForm)) {
			localStorage.setItem('name', encrypt(this.educationDetailsForm.value.nameOnDegree))
			this.loader = true;
			this.loaderService.setValue(this.loader)
			let payload = {
				data: this.educationDetailsForm.value

			};
			if(this.educationDetailsData.isLocked){
				payload.data.startDate = this.educationDetailsData.startDate
				payload.data.endDate = this.educationDetailsData.endDate
				payload.data.qualificationId = this.educationDetailsData.qualificationId
				payload.data.isIncompleteEducation = this.educationDetailsData.isIncompleteEducation
				payload.data.currentEnrolmentInd = this.educationDetailsData.currentEnrolmentInd
				payload.data.countryId = this.educationDetailsData.countryId
				payload.data.cityId = this.educationDetailsData.cityId
				payload.data.universityId = this.educationDetailsData.universityId
				payload.data.sectorCode = this.educationDetailsData.sectorCode
				payload.data.universityDegreeProgramId = this.educationDetailsData.universityDegreeProgramId
				payload.data.degreeProgramId = this.educationDetailsData.degreeProgramId
				payload.data.subjectId = this.educationDetailsData.subjectId
				payload.data.universityNameOnDegreeId = this.educationDetailsData.universityNameOnDegreeId
				payload.data.campusId = this.educationDetailsData.campusId
				payload.data.universityDepartmentId = this.educationDetailsData.universityDepartmentId
				payload.data.campusId = this.educationDetailsData.campusId
				payload.data.degreeTypeId = this.educationDetailsData.degreeTypeId
				payload.data.sessionTypeId = this.educationDetailsData.sessionTypeId
				payload.data.specializationSubjectId = this.educationDetailsData.specializationSubjectId
				payload.data.isResearchWork = this.educationDetailsData.isResearchWork
				payload.data.examSystemTypeCode = this.educationDetailsData.examSystemTypeCode
			}
			if (this.qualId == 7 || this.qualId == 8) {
				payload.data.gradingSystemCodeId = 10543;
			}
			payload.data.qualificationLevelCode = payload.data.qualificationId
			payload.data.educationId = this.educationDetailsData.educationId
			payload.data.activeIndicator = true;
			delete payload.data.nameOnDegree;
			delete payload.data.searchCtrl;
			payload.data.isResearchWork = payload.data.isResearchWork == 'Yes' ? true : false;
			payload.data.startDate = new Date(payload.data.startDate).getFullYear() + '-' + (new Date(payload.data.startDate).getMonth() + 1) + '-' + (new Date(payload.data.startDate).getDate())
			payload.data.endDate = new Date(payload.data.endDate).getFullYear() + '-' + (new Date(payload.data.endDate).getMonth() + 1) + '-' + new Date(payload.data.endDate).getDate()

			this.sharedServices.saveOrUpdateEducation(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = false;
						// this.getEducationDetails();
						let emitData = {
							statusCode: res.statusCode,
							id: payload.data.educationId
						}
						this.educationUpdated.emit(emitData);
					} else {
						this.loader = false;
						this.loaderService.setValue(this.loader)
						this.isAlertVisible = true;
						this.alertBoxMsg('Error in saving education form');
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertBoxMsg('Error in saving education form');
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
					setTimeout(() => {
						this.isAlertVisible = false;
						this.cdr.detectChanges();
					}, 3000);
				}
			)
		}
		else {
			if (this.findInvalidControls().length > 0) {
				let fields = this.findInvalidControls().join(', ')
				this.alertBoxMsg('Please fill all the mandatory fields with valid data');
				this.isAlertVisible = true;
				this.cdr.detectChanges()
			}
		}
	}

	public findInvalidControls() {
		const invalid = [];
		const controls = this.educationDetailsForm.form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	private alertBoxMsg(message, alertType?) {
		if (alertType == 'success') {
			this.alertClass = 'alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-check-circle'
		} else if (alertType == 'warning') {
			this.alertClass = 'alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fas fa-exclamation-circle'
		} else {
			this.alertClass = 'alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40';
			this.alertIcon = 'fa fa-exclamation-triangle'
		}
		this.alertMsgValue = message;
	}
}
